<template>
  <section class="vehicle-page-lease-inclusions">
    <div class="vehicle-page-lease-inclusions__container">
      <div class="vehicle-page-lease-inclusions__content">
        <div class="vehicle-page-lease-inclusions__title-wrap">
          <h2 class="vehicle-page-lease-inclusions__title">{{ title }}</h2>
        </div>
        <p class="vehicle-page-lease-inclusions__intro">{{ intro }}</p>
      </div>
      <div class="vehicle-page-lease-inclusions__items">
        <LeaseInclusionVehicleResult />
      </div>
    </div>
  </section>
</template>

<script>
import LeaseInclusionVehicleResult from '../LeaseInclusion/LeaseInclusionVehicleResult.vue';

export default {
  name: 'VehiclePageLeaseInclusions',
  components: {
    LeaseInclusionVehicleResult
  },
  props: {
    title: {
      type: String,
      default: 'Whats included in a business lease?'
    },
    intro: {
      type: String,
      default: 'Your lease includes exclusive use of the vehicle and most running costs bundled into one fixed monthly payment.'
    }
  }
};
</script>
